module.exports = __webpack_public_path__ + "img/ring_y_i_1_0.1f5a8a51.png";